import type { GlobalHomeWidgetLayoutEntry } from './widget-types'

/**
 * Code-defined global Home layout. Future Folder Dashboard bet may parse the same
 * widget type ids from workspace `.flownotes-home.md` shortcodes.
 */
export const GLOBAL_HOME_LAYOUT: GlobalHomeWidgetLayoutEntry[] = [
  { type: 'welcome-header', columns: 12 },
  { type: 'recent-activity', columns: 6, column: 'left', config: { limit: 10, sort: 'edited' } },
  // smart-suggestions disabled (2026-07-21 Continuity workover) - keep section file for re-enable
  { type: 'inbox-feed', columns: 6, column: 'right', config: { limit: 5 } },
  { type: 'recent-chats-feed', columns: 6, column: 'right', config: { limit: 5 } },
  { type: 'flows-feed', columns: 6, column: 'right', config: { limit: 5 } },
  { type: 'quick-actions', columns: 12 },
]

export const GLOBAL_HOME_BASECAMP_BOOKMARKS: GlobalHomeWidgetLayoutEntry = {
  type: 'basecamp-bookmarks',
  columns: 6,
  column: 'left',
}

export const GLOBAL_HOME_BASECAMP_PROJECTS: GlobalHomeWidgetLayoutEntry = {
  type: 'basecamp-projects',
  columns: 12,
}
